import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Global } from 'src/app/global/global';

@Injectable({
  providedIn: 'root'
})
export class ConversationStarterService {

  constructor(private httpClient: HttpClient) { }


  getConversationStarterquestion(){
    return this.httpClient.get(Global.BASE_API_URL + "/api/conversationstarter", {responseType: 'text'});
  }
}
